import {Pipe, PipeTransform} from '@angular/core';
import IGuid = System.IGuid;
import ICropRotationCell = Data.FieldManagement.ICropRotationCell;

/**
 * get the Saving State for a Cell
 */
@Pipe({
  name: 'getSavingState'
})
export class GetSavingStatePipe implements PipeTransform {

  transform(value: ICropRotationCell[], args?: [IGuid, number]): boolean {
    return !!value.Find(i => i.FieldId === args[0] && i.Year === args[1]);
  }

}
